import Glide, { Controls } from "@glidejs/glide";
import $ from "jquery";

$(() => {
  if (document.querySelector('.listing-carousel')) {    
    const carousels = $(".listing-carousel");
    if (carousels.length) {
      carousels.each((i, carouselEl) => {
        const carousel = $(carouselEl);
        const arrows = carousel.children(".glide").children(".glide__row").children(".glide__arrows");
        const bullets = carousel.children(".glide").children(".glide__bullets")
        const track = $(".glide__row").children(".es-wrap");
        track.addClass("glide__track");
        track.attr('data-glide-el', 'track');
        track.children(".es-dropdown-container").remove();
        const frame = track.children(".es-listing");
        frame.addClass("glide__slides");
        const slides = frame.children(".properties");
        slides.addClass("glide__slide");
        const getGap = () => {
          const gap = parseInt(carousel.find(".glide").css("paddingRight"));
          const windowWidth = $(window).outerWidth();
          // console.log(windowWidth);
          if (windowWidth < 1024) {
            return gap + 11;
          }
          if (windowWidth >= 1024) {
            return 22;
          }
        };
        const getPerView = () => {
          const windowWidth = $(window).outerWidth();
          if (windowWidth < 580) {
            return 1;
          }
          if (windowWidth < 1024) {
            return 2;
          }
          if (windowWidth >= 1024) {
            return 3;
          }
        };
        const glide = new Glide(carousel.find(".glide")[0], {
          rewind: true,
          perView: getPerView(),
          gap: getGap(),
          bound: true
        });
        const generateBullets = () => {
          bullets.children(".glide__bullet").remove();
          let bulletNumber = carousel.children(".glide").children(".glide__row").children(".glide__track").children(".glide__slides").children(".glide__slide").length;
          for( let i = 0; i < bulletNumber; i++ ) {
            let newBullet = $("<button>").appendTo(bullets);
            newBullet.addClass("glide__bullet");
            newBullet.attr('data-glide-dir', '=' + i );
          }
        }
        generateBullets();
        glide.mount();
        glide.on("resize", () => {
          // console.log(getGap(), getPerView());
          glide.update({ gap: getGap(), perView: getPerView() });
          glide.go('<<');
          updateBullets();
        });
        glide.on("move.after", () => {
          const index = glide.index + 1;
          carousel.find(".carousel-index").text(index);
        });
        ///////////////////////////
        const updateBullets = () => {
          let redundantBullets = getPerView() - 1;
          bullets.children(".glide__bullet").removeClass("hidden");
          arrows.removeClass("hidden");
          console.log("Redundant Bullets : ", redundantBullets);
          if( redundantBullets > 0 ) {
            bullets.children(".glide__bullet").slice(-redundantBullets).addClass("hidden");
          };
          console.log("Bullet length : ", bullets.children(".glide__bullet").length);
          if( bullets.children(".glide__bullet").length - redundantBullets <= 1 ) {
            console.log("no bullets needed");
            bullets.children(".glide__bullet").addClass("hidden");
            arrows.addClass("hidden");
          }
        }
        updateBullets();
        /////////////////////////////
      });
    }
  }
});
